<template>
    <div class="flex items-end"  v-if="price">
        <div>
            <div class="text-xs text-gray-600 uppercase">
              <span class="hidden sm:inline">Price </span><span v-if="price.tax.rate > 0">excl.</span>
            </div>
            <div class="inline-block sm:text-xl font-medium">{{ settings.currency }}{{ this.$store.getters['prices/totalPrice'].toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
        </div>

        <div class="ml-4 sm:ml-8" v-if="price.tax.rate > 0">
            <div class="text-xs text-gray-600 uppercase">
              <span class="hidden sm:inline">Price </span>inc.
            </div>
            <div class="inline-block sm:text-xl font-medium">{{ settings.currency }}{{ this.$store.getters['prices/totalPriceIncTax'].toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
        </div>

        <div class="inline-block ml-2">
            <button @click="setComputedPrice"
                    class="inline-block w-5 h-4 mr-2"
                    :class="[ this.$store.getters['prices/priceTotalMode'] === 'COMPUTED' ? 'text-black': 'text-gray-400 hover:text-black' ]">
                <IconBeaker></IconBeaker>
            </button>
            <button @click="setFixedPrice"
                    class="inline-block w-5 h-4"
                    :class="[ this.$store.getters['prices/priceTotalMode'] === 'FIXED' ? 'text-black': 'text-gray-400 hover:text-black' ]">
                <IconPencil></IconPencil>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import IconPencil from '@/components/icons/IconPencil'
import IconBeaker from '@/components/icons/IconBeaker'

export default {
    name: 'PriceTotal',
    components: {
        IconPencil,
        IconBeaker,
    },
    computed: {
        ...mapState('settings', {
            settings: 'settings'
        }),
        ...mapState('prices', {
            price: 'price'
        }),
    },
    methods: {
        setComputedPrice(){
            this.$store.commit('prices/SET_PRICE_TOTAL_MODE', 'COMPUTED')
        },
        setFixedPrice(){
            this.$root.$emit('show-fixed-price-modal')
        }
    },
    mounted(){
    }
}
</script>